/**
 * Stopwatch-style elapsed since an epoch-ms start: under a minute → `Ns`;
 * a minute or more → `mm:ss`. Shared by the Background Tasks cards and the
 * live-progress dialog (FRONT-719) so both read the clock the same way.
 * `now` is injectable for tests; defaults to Date.now().
 */
export function formatElapsed(startMs: number | undefined, now: number = Date.now()): string {
  if (!startMs || !Number.isFinite(startMs)) return '';
  const s = Math.max(0, Math.floor((now - startMs) / 1000));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  return `${String(m).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
}
